// extracted by mini-css-extract-plugin
export var main = "StreamPlayer-module--main--3IYfE";
export var isVisible = "StreamPlayer-module--isVisible--ow2vO";
export var cover = "StreamPlayer-module--cover--2W4Xz";
export var contained = "StreamPlayer-module--contained--36zIN";
export var vertical = "StreamPlayer-module--vertical--1puba";